import React, { useState } from 'react';

// Per-section download buttons (DXF/SVG/PDF). Each LayoutNavSection renders
// its own copy and passes the items selected within that section. The buttons
// stay disabled until the section reports it's not in a redraw and at least
// one item is picked.
const PerSectionDownloadButtons = ({ items, activeRedraws }) => {
  const [dimensionLinesDXF, setDimensionLinesDXF] = useState(true);
  const [dimensionLinesSVG, setDimensionLinesSVG] = useState(true);
  const [dimensionLinesPDF, setDimensionLinesPDF] = useState(true);

  const disabled = items.length === 0 || activeRedraws.length > 0;

  const triggerDownload = (extension, dimensionLinesIncluded) => {
    show_layout_confirm(extension, { items, dimensionLinesIncluded });
  };

  const renderButton = (extension, dimensionLinesIncluded, setDimensionLinesIncluded, iconSrc, labelKey) => (
    <div className="inner">
      <div className="child">
        <input
          type="checkbox"
          checked={dimensionLinesIncluded}
          onChange={(e) => setDimensionLinesIncluded(e.target.checked)}
        />
        &nbsp;{t('layouts.download_with_dimension_borders')}
        <br />
        <button
          disabled={disabled ? 'disabled' : ''}
          className="btn btn-default btn-lg download-btn"
          onClick={(e) => { e.preventDefault(); triggerDownload(extension, dimensionLinesIncluded); }}
        >
          <img className="downloadIcon" src={iconSrc} /> &nbsp; {t(labelKey)}
        </button>
      </div>
    </div>
  );

  return (
    <div className="downloadButtonscontainer per-section-downloads">
      {renderButton('dxf', dimensionLinesDXF, setDimensionLinesDXF, window.dxf_icon, 'models.download_as_dxf')}
      {renderButton('svg', dimensionLinesSVG, setDimensionLinesSVG, window.svg_icon, 'models.download_as_svg')}
      {renderButton('pdf', dimensionLinesPDF, setDimensionLinesPDF, window.pdf_icon, 'models.download_as_pdf')}
    </div>
  );
};

export default PerSectionDownloadButtons;
